import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import RichText from 'src/components/richtext/Richtext';
import styles from './InfoBox.module.css';
import Color from 'src/lib/types/Color';
import { IMessageBanner } from 'src/lib/types/Settings';

// TODO: Skal ligge på følgende steder:
/*
✓ Forsiden
✓ SG alle sider bortsett fra søk
✓ Kinoprogram
Filmomtale
Filmquiz
kommer
kinotoppen
trailere
*/

//#region [Props]
type InfoBoxProps = {
	messageBanner: IMessageBanner;
	className?: string;
};
//#endregion

//#region [Component]
export default function InfoBox({ messageBanner, className }: InfoBoxProps) {
	if (!messageBanner.messageBannerActive) {
		return null;
	}

	return <div className={`${styles.SInfoBoxWrapper} ${className || ''}`}>
		<BannerTypeSelector link={messageBanner.link} bgColor={messageBanner.bgColor} textColor={messageBanner.textColor}>
			<div className={styles.SDescripton}><RichText value={messageBanner.messageText} /></div>
			{messageBanner.linkText && <div className={styles.SButton}
				style={{
					backgroundColor: messageBanner.buttonBgColor?.hex || "var(--palette-lilla-mørk-hovedfarge)",
					color: messageBanner.buttonTextColor?.hex || "white"
				}}
			>{messageBanner.linkText}</div>}
		</BannerTypeSelector>
	</div>;
}
//#endregion



//#region [Props]
type BannerTypeSelectorProps = {
	link?: string;
	bgColor?: Color;
	textColor?: Color;
	children: React.ReactNode;
}
//#endregion

//#region [Component]
function BannerTypeSelector({ link, children, bgColor, textColor }: BannerTypeSelectorProps) {
	if (!link?.trim()) {
		return <div className={styles.SContentElem}
			style={{
				backgroundColor: bgColor?.hex || "#eb1e59",
				color: textColor?.hex || "white"
			}}
		>{children}</div>
	}
	return <FilmwebLink className={styles.SContentLink}
		to={link!} 
		style={{
			backgroundColor: bgColor?.hex || "#eb1e59",
			color: textColor?.hex || "white"
		}}
	>{children}</FilmwebLink>
}
//#endregion

